import { useState, useCallback, useEffect } from "react";
import { supabase } from "../supabase";
import { C } from "../lib/constants";
import { Btn } from "./ui/Btn";
import { TopNav } from "./ui/TopNav";
import { Chip } from "./ui/Chip";
import { Card } from "./ui/Card";
import { EstadoChip, FlowTimeline, MediationBox, EmptyBox, MediacionModal, getFlowInfo } from "./WorkFlow";

const enviarWhatsAppResena = (clienteTelefono, trabajadorNombre, solicitudId) => {
  const phone = String(clienteTelefono || "").replace(/\D/g, "");
  if (!phone) return;
  const appUrl = `${window.location.origin}?resena=${solicitudId}`;
  const msg = encodeURIComponent(
`¡Hola! 👋 Tu trabajo con *${trabajadorNombre || "el trabajador"}* en FICIO ha finalizado.

¿Cómo te fue? Tu opinión ayuda a otros clientes y mejora la comunidad.

⭐ Califica el servicio aquí:
${appUrl}

Solo toma 1 minuto. ¡Gracias por usar FICIO! 🏗️`
  );
  window.open(`https://wa.me/52${phone}?text=${msg}`, "_blank");
};

const StatMini = ({label,value,color}) => <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:14,padding:'12px 8px',textAlign:'center',boxShadow:'0 2px 6px rgba(0,0,0,.04)'}}><div style={{fontFamily:'Georgia, serif',fontSize:20,fontWeight:900,color}}>{value}</div><div style={{color:C.muted,fontSize:10,fontWeight:700}}>{label}</div></div>;

const TrabajoCard = ({solicitud, onWhats, onStatus, onMediacion}) => {
  const status = solicitud.estado || solicitud.status || "pendiente";
  const statusInfo = getFlowInfo(status);

  const fecha = solicitud.created_at
    ? new Date(solicitud.created_at).toLocaleDateString("es-MX", { day:"2-digit", month:"short", year:"numeric" })
    : "";

  const puedeAceptar = status === "pendiente";
  const puedeIniciar = status === "aceptada";
  const puedeConcluir = status === "en_progreso";

  return (
    <div style={{background:C.surface,border:`1.5px solid ${statusInfo.color}30`,borderRadius:18,padding:16,boxShadow:"0 2px 8px rgba(0,0,0,.04)"}}>
      <div style={{display:"flex",justifyContent:"space-between",gap:10,alignItems:"flex-start",marginBottom:10}}>
        <div>
          <div style={{fontFamily:"Georgia, serif",fontSize:17,fontWeight:900,color:C.text,marginBottom:2}}>
            {solicitud.cliente_nombre || "Cliente"}
          </div>
          <div style={{color:C.muted,fontSize:11}}>
            {fecha} · 📍 {solicitud.zona || "Sin zona"}
          </div>
        </div>
        <EstadoChip status={status}/>
      </div>

      <FlowTimeline status={status}/>
      <MediationBox solicitud={solicitud}/>

      <div style={{background:C.bg,borderRadius:14,padding:13,marginBottom:12}}>
        <div style={{display:"flex",justifyContent:"space-between",gap:10,borderBottom:`1px solid ${C.divider}`,paddingBottom:7,marginBottom:7}}>
          <span style={{color:C.muted,fontSize:12}}>Servicio</span>
          <span style={{color:C.text,fontSize:12,fontWeight:800,textAlign:"right"}}>{solicitud.oficio || "No especificado"}</span>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",gap:10,borderBottom:`1px solid ${C.divider}`,paddingBottom:7,marginBottom:7}}>
          <span style={{color:C.muted,fontSize:12}}>Presupuesto cliente</span>
          <span style={{color:C.green,fontSize:12,fontWeight:900,textAlign:"right"}}>
            {solicitud.presupuesto ? `$${Number(solicitud.presupuesto).toLocaleString("es-MX")}` : "No definido"}
          </span>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",gap:10}}>
          <span style={{color:C.muted,fontSize:12}}>Fecha preferida</span>
          <span style={{color:C.text,fontSize:12,fontWeight:800,textAlign:"right"}}>
            {solicitud.fecha_preferida || "Flexible"}
          </span>
        </div>
      </div>

      <div style={{color:C.sub,fontSize:12,lineHeight:1.5,marginBottom:13}}>
        {solicitud.descripcion}
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
        <Btn small full color="#25D366" onClick={onWhats}>
          💬 WhatsApp
        </Btn>
        {puedeAceptar ? (
          <Btn small full color={C.blue} onClick={()=>onStatus("aceptada")}>
            Aceptar trabajo
          </Btn>
        ) : puedeIniciar ? (
          <Btn small full color={C.green} onClick={()=>onStatus("en_progreso")}>
            Iniciar trabajo
          </Btn>
        ) : puedeConcluir ? (
          <Btn small full color={C.green} onClick={()=>onStatus("completada", {concluded_by:"trabajador"})}>
            Concluir trabajo
          </Btn>
        ) : (
          <Btn small full outline color={statusInfo.color} onClick={()=>window.ficioToast?.(`Estado: ${statusInfo.label}`, "info")}>
            {statusInfo.label}
          </Btn>
        )}
      </div>

      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
        <Btn small full outline color={C.blue} onClick={()=>onStatus("aceptada")}>
          Cliente autorizó
        </Btn>
        <Btn small full outline color={C.red} onClick={onMediacion}>
          ⚖️ Mediación $500
        </Btn>
      </div>
    </div>
  );
};

export const SolicitudesTrabajador = ({setScreen, user, profile}) => {
  const [solicitudes,setSolicitudes]=useState([]);
  const [trabajadorActual,setTrabajadorActual]=useState(null);
  const [loading,setLoading]=useState(false);
  const [errorMsg,setErrorMsg]=useState("");
  const [statusFilter,setStatusFilter]=useState("todas");
  const [mediacionTarget,setMediacionTarget]=useState(null);
  const [mediacionReason,setMediacionReason]=useState("");
  const userId = user?.id || null;

  const cargar=useCallback(async()=>{
    setErrorMsg("");
    if(!userId){setSolicitudes([]);setTrabajadorActual(null);return;}
    setLoading(true);

    // FIX SESIÓN CRUZADA: verificar que la sesión activa coincide con el userId del prop
    // antes de cargar cualquier dato de trabajador o solicitudes.
    const { data: authCheck } = await supabase.auth.getUser();
    const currentUid = authCheck?.user?.id;
    if (!currentUid || currentUid !== userId) {
      console.warn("FICIO: Discrepancia de sesión en SolicitudesTrabajador — abortando carga");
      setSolicitudes([]);
      setTrabajadorActual(null);
      setErrorMsg("Error de sesión. Cierra sesión e inicia de nuevo.");
      setLoading(false);
      return;
    }

    let trabajador = null;

    // FIX SESIÓN CRUZADA: SOLO buscar por user_id — eliminados todos los fallbacks por teléfono.
    // Los fallbacks por teléfono podían vincular perfiles de usuarios distintos
    // si dos cuentas tenían el mismo número registrado.
    const {data:workerByUser,error:workerUserError}=await supabase
      .from("trabajadores")
      .select("id,nombre,telefono,oficio,zona,user_id")
      .eq("user_id",userId)
      .neq("archivado",true)
      .maybeSingle();

    if(workerUserError) console.warn("Error buscando trabajador por user_id:", workerUserError.message);
    if(workerByUser) trabajador = workerByUser;


    if(!trabajador){
      setSolicitudes([]);
      setTrabajadorActual(null);
      setErrorMsg("Esta cuenta no tiene un perfil de trabajador registrado. Completa tu registro en 'Registrarme como Maestro'.");
      setLoading(false);
      return;
    }

    // FIX SESIÓN CRUZADA: validar que el trabajador encontrado pertenece a este usuario
    if(trabajador.user_id && trabajador.user_id !== userId){
      console.warn("FICIO: trabajador.user_id no coincide con userId — bloqueando carga");
      setSolicitudes([]);
      setTrabajadorActual(null);
      setErrorMsg("Error de integridad: el perfil no pertenece a esta cuenta.");
      setLoading(false);
      return;
    }

    setTrabajadorActual(trabajador);

    // FIX SESIÓN CRUZADA: solicitudes filtradas SOLO por trabajador_user_id.
    // Eliminado el filtro por trabajador_telefono — podía retornar solicitudes de otro trabajador.
    const filtrosTrabajador = [`trabajador_user_id.eq.${userId}`];
    if (trabajador?.id) filtrosTrabajador.push(`trabajador_id.eq.${trabajador.id}`);
    // ELIMINADO: trabajador_telefono — riesgo de cruce entre cuentas con el mismo número

    const {data,error}=await supabase
      .from("solicitudes")
      .select("*")
      .or(filtrosTrabajador.join(","))
      .order("created_at",{ascending:false});

    if(error){
      setErrorMsg(error.message);
      setSolicitudes([]);
    } else {
      // FIX SESIÓN CRUZADA: solo actualizar solicitudes que pertenezcan a este usuario
      const sinVincular=(data||[]).filter(s=>!s.trabajador_user_id && s.trabajador_id===trabajador.id);
      for(const s of sinVincular){
        await supabase.from("solicitudes").update({trabajador_user_id:userId}).eq("id",s.id);
      }
      setSolicitudes(data||[]);
    }
    setLoading(false);
  },[userId]);

  // FIX SESIÓN CRUZADA: deps reducidas — userPhone eliminado (ya no se usa en cargar)
  useEffect(()=>{cargar();const chName=`solicitudes-trabajador-${userId||"anon"}`;const channel=supabase.channel(chName).on("postgres_changes",{event:"*",schema:"public",table:"solicitudes"},cargar).subscribe();return()=>supabase.removeChannel(channel);},[cargar,userId]);

  const actualizarStatus=async(id,estado,extra={})=>{
    const payload={estado,updated_at:new Date().toISOString(),...extra};
    if(estado==="en_progreso") payload.started_at=new Date().toISOString();
    if(estado==="completada"){
      payload.finished_at=new Date().toISOString();
      payload.trabajador_concluyo=true;
      const sol = solicitudes.find(s=>s.id===id);
      if(sol?.cliente_telefono){
        setTimeout(()=>enviarWhatsAppResena(sol.cliente_telefono, trabajadorActual?.nombre || sol.trabajador_nombre, id), 500);
      }
    }
    if(estado==="mediacion_solicitada"){payload.mediation_requested_by="trabajador";payload.mediation_fee=500;payload.mediation_requested_at=new Date().toISOString();}
    const {error}=await supabase.from("solicitudes").update(payload).eq("id",id).eq("trabajador_user_id",userId);
    if(error){console.error("Error actualizando solicitud:", error.message); return;}
    cargar();
  };

  const solicitarMediacion=async()=>{if(!mediacionTarget)return;if(!mediacionReason.trim()){window.ficioToast?.("Escribe brevemente el motivo de la mediación.");return;}await actualizarStatus(mediacionTarget.id,"mediacion_solicitada",{mediation_reason:mediacionReason.trim()});setMediacionTarget(null);setMediacionReason("");};

  const abrirWhats=(s)=>{
    const phone=String(s.cliente_telefono||"").replace(/\D/g,"");
    if(!phone){window.ficioToast?.("La solicitud no tiene teléfono del cliente", "warn");return;}
    const msg=encodeURIComponent(`Hola ${s.cliente_nombre||""} 👋

Soy el trabajador que viste en FICIO.
Vi tu solicitud sobre: ${s.oficio||"servicio"}

Descripción:
${s.descripcion||""}

¿Podemos revisar detalles para darte una cotización?`);
    window.open(`https://wa.me/52${phone}?text=${msg}`,"_blank");
  };

  const filtered=solicitudes.filter(s=>statusFilter==="todas"?true:(s.estado||"pendiente")===statusFilter);
  const counts={todas:solicitudes.length,pendiente:solicitudes.filter(s=>(s.estado||"pendiente")==="pendiente").length,aceptada:solicitudes.filter(s=>s.estado==="aceptada").length,en_progreso:solicitudes.filter(s=>s.estado==="en_progreso").length,completada:solicitudes.filter(s=>s.estado==="completada").length,cancelada:solicitudes.filter(s=>s.estado==="cancelada").length,mediacion_solicitada:solicitudes.filter(s=>["mediacion_solicitada","en_mediacion"].includes(s.estado||s.status)).length};

  if(!user){
    return <div style={{minHeight:"100vh",background:C.bg,paddingBottom:100}}><TopNav setScreen={setScreen} back="landing" backLabel="Inicio" title="Mis trabajos"/><div style={{maxWidth:640,margin:"0 auto",padding:"20px 20px 0"}}><EmptyBox icon="🔐" title="Inicia sesión" desc="Para ver tus trabajos debes entrar con tu cuenta de trabajador."/><div style={{height:12}}/><Btn full color={C.accent} onClick={()=>setScreen("cliente-login")}>Entrar a mi cuenta</Btn></div></div>;
  }

  return (
    <div style={{minHeight:"100vh",background:C.bg,paddingBottom:100}}>
      <TopNav setScreen={setScreen} back="landing" backLabel="Inicio" title="Mis trabajos"/>
      <div style={{maxWidth:640,margin:"0 auto",padding:"20px 20px 0"}}>
        <div style={{background:`linear-gradient(135deg,${C.accent},${C.accentD})`,borderRadius:22,padding:22,color:"#fff",marginBottom:16,boxShadow:"0 6px 22px rgba(212,120,58,.25)"}}>
          <div style={{fontSize:32,marginBottom:8}}>🔐</div>
          <div style={{fontFamily:"Georgia, serif",fontSize:25,fontWeight:900,marginBottom:4}}>Mis trabajos privados</div>
          <div style={{fontSize:13,opacity:.85,lineHeight:1.5}}>Esta bandeja solo se abre con tu sesión de trabajador. Ya no se consulta por teléfono manual.</div>
        </div>

        <Card>
          <div style={{color:C.sub,fontSize:11,fontWeight:800,letterSpacing:.8,textTransform:"uppercase",marginBottom:8}}>Cuenta activa</div>
          <div style={{display:"flex",justifyContent:"space-between",gap:12,alignItems:"center"}}>
            <div>
              <div style={{fontFamily:"Georgia, serif",fontSize:17,fontWeight:900,color:C.text}}>{profile?.nombre || user.email}</div>
              <div style={{color:C.muted,fontSize:12}}>{trabajadorActual ? `Perfil: ${trabajadorActual.nombre}` : "Buscando perfil de trabajador..."}</div>
            </div>
            <Chip text="Privado" color={C.green} small/>
          </div>
        </Card>

        {errorMsg&&<div style={{background:C.redL,border:`1.5px solid ${C.red}35`,borderRadius:14,padding:"12px 14px",color:C.red,marginBottom:14,fontSize:12}}>{errorMsg}</div>}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:12}}>
          <StatMini label="Nuevas" value={counts.pendiente} color={C.accent}/>
          <StatMini label="Proceso" value={counts.en_progreso} color={C.green}/>
          <StatMini label="Mediación" value={counts.mediacion_solicitada} color={C.red}/>
        </div>

        <div style={{display:"flex",gap:6,overflowX:"auto",paddingBottom:8,marginBottom:8}}>
          {[["todas","Todas"],["pendiente","Nuevas"],["aceptada","Aceptadas"],["en_progreso","En proceso"],["completada","Completadas"],["cancelada","Canceladas"],["mediacion_solicitada","Mediación"]].map(([id,label])=>(
            <button key={id} onClick={()=>setStatusFilter(id)} style={{border:"none",borderRadius:20,padding:"8px 12px",cursor:"pointer",background:statusFilter===id?C.accent:C.surface,color:statusFilter===id?"#fff":C.sub,fontWeight:800,fontSize:12,whiteSpace:"nowrap",boxShadow:"0 2px 6px rgba(0,0,0,.04)"}}>{label} ({counts[id]||0})</button>
          ))}
        </div>

        {loading?<div style={{textAlign:"center",padding:"42px 0",color:C.muted}}>Cargando trabajos...</div>:filtered.length===0?<EmptyBox icon="📭" title="Sin trabajos" desc="Cuando un cliente solicite cotización desde tu perfil aparecerá aquí."/>:<div style={{display:"flex",flexDirection:"column",gap:12}}>{filtered.map(s=><TrabajoCard key={s.id} solicitud={s} onWhats={()=>abrirWhats(s)} onStatus={(status,extra)=>actualizarStatus(s.id,status,extra)} onMediacion={()=>setMediacionTarget(s)}/>)}</div>}
      </div>
      {mediacionTarget&&<MediacionModal solicitud={mediacionTarget} reason={mediacionReason} setReason={setMediacionReason} onClose={()=>{setMediacionTarget(null);setMediacionReason("");}} onConfirm={solicitarMediacion}/>}
    </div>
  );
};
